import React from 'react';
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import SubAdminSideBar from '../SubAdminSideBar';
import CommunicationHub from '../CommunicationHub';

const ComminicationHubSubadminPage = () => {
  return (
    <React.Fragment>
    <SubAdminSideBar>
       <CommunicationHub />
    </SubAdminSideBar>
  </React.Fragment>
  );
}

export default NetworkDetector(ComminicationHubSubadminPage);
